import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PasscodeSheet } from "../components/PasscodeSheet";
import { setupApi } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function Setup() {
  const [first, setFirst] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { refresh } = useAuth();

  const handleSubmit = async (code: string) => {
    setError(null);
    if (first === null) {
      setFirst(code);
      return;
    }
    if (code !== first) {
      setError("Codes don't match — start over");
      setFirst(null);
      return;
    }
    try {
      await setupApi(code);
      await refresh();
      navigate("/", { replace: true });
    } catch (e) {
      setError(e instanceof Error ? e.message : "Setup failed");
      setFirst(null);
    }
  };

  const title = first === null ? "Set a 6-digit passcode" : "Confirm passcode";
  const subtitle =
    first === null
      ? "This protects Health, Finance, Work, and Family vaults. Main is always accessible."
      : "Re-enter the same 6 digits to confirm.";

  return (
    <div className="min-h-screen flex flex-col items-center pt-12 px-4 bg-gradient-to-b from-attic-bg to-[#f0f2f5]">
      <h1 className="text-3xl font-extrabold text-attic-accent mb-1">attic</h1>
      <p className="text-attic-dim text-xs mb-8">your knowledge, queryable</p>
      <PasscodeSheet
        title={title}
        subtitle={subtitle}
        errorMessage={error ?? undefined}
        onSubmit={handleSubmit}
        onCancel={() => {}}
      />
    </div>
  );
}
